import { render, staticRenderFns } from "./faceAuthenticationWarningScreen.vue?vue&type=template&id=654ef665&scoped=true"
import script from "./faceAuthenticationWarningScreen.vue?vue&type=script&lang=js"
export * from "./faceAuthenticationWarningScreen.vue?vue&type=script&lang=js"
import style0 from "./faceAuthenticationWarningScreen.vue?vue&type=style&index=0&id=654ef665&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654ef665",
  null
  
)

export default component.exports